var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:[{ 'nav-open': _vm.$sidebar.showSidebar }]},[_c('notifications'),_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('mobile-menu'),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{ name: 'Dashboard', icon: 'bar_chart', path: '/dashboard' }}}),(_vm.loadPortfolio)?_c('sidebar-item',{attrs:{"link":{
          name: 'Portfolio',
          icon: _vm.plantIcon,
          path: '/portfolio/clients'
        }}}):_vm._e(),(!_vm.loadPortfolio)?_c('sidebar-item',{attrs:{"link":{
          name: 'Portfolio',
          icon: _vm.plantIcon,
          path: '/portfolio/clientId=' + this.globalClient.id
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Statutory Inspections',
          icon: _vm.statInspIcon,
          path: '/stat-insp/stat-insp-list'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Plant without Stat. Insp.',
            path: '/stat-insp/plants-without-stat-insps'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'View Stat. Insp.',
            path: '/stat-insp/stat-insp-list'
          }}})],1),(this.$auth.isInGlobalRole() || this.$auth.isInRole(4))?_c('sidebar-item',{attrs:{"link":{
          name: 'Data Management',
          icon: 'all_inbox',
          path: '/'
        }}},[(this.$auth.isInGlobalRole() || this.$auth.isInRole(4))?_c('sidebar-item',{attrs:{"link":{ name: 'Clients', path: '/datamanagement/clients' }}}):_vm._e(),(this.$auth.isInGlobalRole())?_c('sidebar-item',{attrs:{"link":{ name: 'Contractors', path: '/datamanagement/contractors' }}}):_vm._e(),(this.$auth.isInGlobalRole())?_c('sidebar-item',{attrs:{"link":{ name: 'Consultants', path: '/datamanagement/consultants' }}}):_vm._e()],1):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Quotes',
          icon: _vm.quoteIcon,
          path: '/'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Live',
            path: '/quotes/live'
          }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Completed', path: '/quotes/completed' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Rejected', path: '/quotes/rejected' }}})],1),(this.$auth.isInRole(4))?_c('sidebar-item',{attrs:{"link":{
          name: 'User Management',
          icon: _vm.userIcon,
          path: '/userManagement'
        }}}):_vm._e()],1)],2),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('alert'),_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }